export const state = {
  filters: {}
}
